module.exports = __webpack_public_path__ + "img/greenBg.187a3f86.png";